export default __webpack_public_path__ + "static/media/Spring.3f824a40.png";